
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import api from '../../../services/api';
import './AddNutricionista.css';


function AddNutricionista({ onSuccess }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setError('');
    setSuccess('');

    if (!name || !email || !password || !passwordConfirmation) {
      setError('Por favor, preencha todos os campos.');
      setIsSubmitting(false);
      return;
    }
    if (password.length < 3) {
      setError('A senha deve ter pelo menos 3 caracteres.');
      setIsSubmitting(false);
      return;
    }
    if (password !== passwordConfirmation) {
      setError('As senhas não coincidem.');
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await api.post('/nutricionista/create', {
        name,
        email,
        password,
        password_confirmation: passwordConfirmation,
        type: 'nutricionista',
      });
      if (response.status === 201 || response.status === 200) {
        setSuccess('Nutricionista cadastrada com sucesso!');
        setName('');
        setEmail('');
        setPassword('');
        setPasswordConfirmation('');
        if (onSuccess) onSuccess();
      } else {
        setError('Erro ao cadastrar nutricionista. Verifique os dados e tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao cadastrar nutricionista:', error);
      const errorMessage =
        error.response?.data?.errors
          ? Object.values(error.response.data.errors).flat().join(' ')
          : (error.response?.data?.message || 'Erro inesperado. Tente novamente.');
      setError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="create-teacher-container">
      <h2>Cadastrar Nova Nutricionista</h2>
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group-inline">
          <div className="form-group">
            <label htmlFor="name">Nome:</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoComplete="name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">E-mail:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>
        </div>

        <div className="form-group-inline">
          <div className="form-group">
            <label htmlFor="password">Senha:</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
              <button
                type="button"
                className="toggle-password"
                style={{ backgroundColor: "transparent" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="password-confirmation">Confirmação de Senha:</label>
            <div className="password-input-container">
              <input
                type={showPasswordConfirmation ? "text" : "password"}
                id="password-confirmation"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                autoComplete="new-password"
              />
              <button
                type="button"
                className="toggle-password"
                style={{ backgroundColor: "transparent" }}
                onClick={() => setShowPasswordConfirmation(!showPasswordConfirmation)}
              >
                {showPasswordConfirmation ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>
        </div>

        <div className="form-group" style={{ marginTop: '1rem' }}>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Cadastrando...' : 'Cadastrar Nutricionista'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddNutricionista;
